import LoyaltyPoint from "./loyaltyPoint.container";

export default LoyaltyPoint;